<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import axios from "axios";
import TabelSemuaKompetensi from "./components/TabelSemuaKompetensi.vue";
import TabelViolation from "./components/TabelViolation.vue";
import ModalExportListQueue from "@/router/layouts/export/modal-export-list-queue.vue";

export default {
  page: {
    title: "Report Proctor Peserta Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    TabelSemuaKompetensi,
    TabelViolation,
    ModalExportListQueue,
  },

  data() {
    return {
      title: "Report Proctor Peserta Detail",

      headerParam: {
        idjadwal: null,
        idjadwal_batch: null,
        idjadwal_peserta: null,
      },

      infoDataPeserta: {
        loading: true,
        kodeTes: null,
        batch: null,
        tanggalBatch: null,
        tanggalSelesai: null,
        nip: null,
        nama: null,
      },

      validasiBobot: {
        loading: true,
        total_soal: null,
        total_skor: null,
        is_valid: null,
        keterangan: null,
        breakdown_per_label: [],
      },

      listKompetensi: [],
      selectedKompetensi: null,

      showModalExportListQueue: false,
      tableKey: 0,
    };
  },

  mounted() {
    this.headerParam.idjadwal = this.$route.query.idjadwal;
    this.headerParam.idjadwal_batch = this.$route.query.idjadwal_batch;
    this.headerParam.idjadwal_peserta = this.$route.query.idjadwal_peserta;

    if (
      this.headerParam.idjadwal &&
      this.headerParam.idjadwal_batch &&
      this.headerParam.idjadwal_peserta
    ) {
      this.getInfoPeserta();
      this.getListKompetensi();
    }
  },

  methods: {
    async getInfoPeserta() {
      try {
        const response = await axios({
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta/info-peserta",
          method: "get",
          params: {
            idjadwal: this.headerParam.idjadwal,
            idjadwal_batch: this.headerParam.idjadwal_batch,
            idjadwal_peserta: this.headerParam.idjadwal_peserta,
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        if (response?.data?.meta?.code == 200) {
          const data = response.data.data;
          this.infoDataPeserta.kodeTes = data.jadwal.kode_tes;
          this.infoDataPeserta.batch = data.jadwal_batch.nama_batch;
          this.infoDataPeserta.tanggalBatch = data.jadwal_batch.waktu_mulai;
          this.infoDataPeserta.tanggalSelesai = data.jadwal_batch.waktu_selesai;
          this.infoDataPeserta.nip = data.nip;
          this.infoDataPeserta.nama = data.nama;
        } else {
          Swal.fire({ icon: "warning", title: "Info", text: "Terdapat kendala saat mengambil data user" });
        }
      } catch (error) {
        console.log(error);
        Swal.fire({ icon: "error", title: "Peringatan", text: "Terjadi kesalahan pada sistem" });
      } finally {
        this.infoDataPeserta.loading = false;
      }
    },

    async getListKompetensi() {
      try {
        const response = await axios({
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta/list-kompetensi",
          method: "get",
          params: { idjadwal_peserta: this.headerParam.idjadwal_peserta },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        if (response?.data?.meta?.code == 200) {
          this.listKompetensi = response.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getValidasiBobot() {
      this.validasiBobot.loading = true;
      try {
        const params = { idjadwal_peserta: this.headerParam.idjadwal_peserta };
        if (this.selectedKompetensi) params.idkompetensi = this.selectedKompetensi;

        const response = await axios({
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta/report-validasi-bobot",
          method: "get",
          params,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        if (response?.data?.meta?.code == 200) {
          const data = response.data.data;
          this.validasiBobot.total_soal = data.total_soal;
          this.validasiBobot.total_skor = data.total_skor;
          this.validasiBobot.is_valid = data.is_valid;
          this.validasiBobot.keterangan = data.keterangan;
          this.validasiBobot.breakdown_per_label = data.breakdown_per_label;
        }
      } catch (error) {
        console.log(error);
        Swal.fire({ icon: "error", title: "Peringatan", text: "Terjadi kesalahan pada sistem" });
      } finally {
        this.validasiBobot.loading = false;
      }
    },

    async updateDataKompetensiValiditas(idkompetensi = null) {
      const label = idkompetensi
        ? this.listKompetensi.find((k) => k.idkompetensi == idkompetensi)?.nama_kompetensi || "Kompetensi Terpilih"
        : "Semua Kompetensi";

      const confirm = await Swal.fire({
        icon: "question",
        title: "Konfirmasi Update",
        html: `
          <table style="width:100%; text-align:left; border-collapse:collapse; font-size:0.9rem;">
            <tr>
              <td style="padding:4px 8px; font-weight:600;">Kompetensi</td>
              <td style="padding:4px 4px;">:</td>
              <td style="padding:4px 8px;">${label}</td>
            </tr>
            <tr>
              <td style="padding:4px 8px; font-weight:600;">Total Skor Error</td>
              <td style="padding:4px 4px;">:</td>
              <td style="padding:4px 8px;">${this.validasiBobot.total_skor ?? '-'}%</td>
            </tr>
            <tr>
              <td style="padding:4px 8px; font-weight:600;">Keterangan</td>
              <td style="padding:4px 4px;">:</td>
              <td style="padding:4px 8px;">
                <span style="
                  padding: 2px 10px;
                  border-radius: 999px;
                  font-weight: 600;
                  background-color: ${this.validasiBobot.is_valid ? '#d1fae5' : '#fee2e2'};
                  color: ${this.validasiBobot.is_valid ? '#065f46' : '#991b1b'};
                ">
                  ${this.validasiBobot.keterangan ?? '-'}
                </span>
              </td>
            </tr>
            <tr>
              <td style="padding:4px 8px; font-weight:600;">Diubah ke</td>
              <td style="padding:4px 4px;">:</td>
              <td style="padding:4px 8px;">
                <span style="
                  padding: 2px 10px;
                  border-radius: 999px;
                  font-weight: 600;
                  background-color: ${this.validasiBobot.is_valid ? '#fee2e2' : '#d1fae5'};
                  color: ${this.validasiBobot.is_valid ? '#991b1b' : '#065f46'};
                ">
                  ${this.validasiBobot.is_valid ? 'TIDAK VALID' : 'VALID'}
                </span>
              </td>
            </tr>
          </table>
        `,
        showCancelButton: true,
        confirmButtonText: "Ya, Update",
        cancelButtonText: "Batal",
      });

      if (!confirm.isConfirmed) return;

      Swal.fire({
        title: "Sedang memproses...",
        text: "Harap tunggu.",
        icon: "info",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        const params = {
          idjadwal: this.headerParam.idjadwal,
          idjadwal_batch: this.headerParam.idjadwal_batch,
          idjadwal_peserta: this.headerParam.idjadwal_peserta,
        };

        if (idkompetensi) params.idkompetensi = idkompetensi;

        const response = await axios({
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta/update-data-kompetensi-validitas",
          method: "put",
          params,
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        if (response?.data?.meta?.code == 200) {
          await Swal.fire({ icon: "success", title: "Berhasil!", text: response.data.data?.message || "Data kompetensi validitas berhasil diperbarui.", timer: 2000, showConfirmButton: false });
          this.getListKompetensi();
          if (idkompetensi) {
            this.getValidasiBobot();
          } else {
            this.tableKey++;
          }
        } else {
          Swal.fire({ icon: "warning", title: "Info", text: response.data?.meta?.message || "Terdapat kendala saat memperbarui data." });
        }
      } catch (error) {
        console.log(error);
        Swal.fire({ icon: "error", title: "Peringatan", text: "Terjadi kesalahan pada sistem" });
      }
    },

    onFilterChange() {
      this.getValidasiBobot();
    },

    formatDateTime(datetime) {
      if (!datetime) return "-";
      const date = new Date(datetime);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    },

    backButton() {
      this.$router.push({
        name: "report-proctor-peserta-detail-list-peserta",
        query: { idjadwal: this.$route.query.idjadwal, idjadwal_batch: this.$route.query.idjadwal_batch },
      });
    },

    exportExcel() {
      let self = this;

      const kompetensiLabel = self.selectedKompetensi
        ? self.listKompetensi.find((k) => k.idkompetensi == self.selectedKompetensi)?.nama_kompetensi || "Kompetensi Terpilih"
        : "Semua Kompetensi";

      Swal.fire({
        title: "Konfirmasi Export",
        html: `Export Excel untuk: <strong>${kompetensiLabel}</strong>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Export",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (!result.isConfirmed) return;

        Swal.fire({
          title: "Sedang memproses...",
          text: "Harap tunggu, export Excel sedang diproses.",
          icon: "info",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            "report-proctor-peserta/export-detail-peserta",
          params: {
            idjadwal: self.headerParam.idjadwal,
            idjadwal_batch: self.headerParam.idjadwal_batch,
            idjadwal_peserta: self.headerParam.idjadwal_peserta,
            idkompetensi: self.selectedKompetensi,
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        })
          .then((response) => {
            const meta = response.data?.meta || {};
            if (meta.code !== 200) {
              Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: meta.message || "Export Excel gagal diproses.",
              });
              return;
            }

            const resData = response.data.data || {};
            Swal.fire({
              icon: "success",
              title: "Berhasil!",
              text: resData.message || "Export report peserta sedang dalam antrian.",
              timer: 2000,
              showConfirmButton: false,
            });

            // const url = window.URL.createObjectURL(new Blob([response.data]));
            // const link = document.createElement("a");
            // link.href = url;
            // const contentDisposition = response.headers["content-disposition"];
            // let fileName = "export-detail-peserta.xlsx";
            // if (contentDisposition) {
            //   const match = contentDisposition.match(/filename="?(.+)"?/);
            //   if (match) fileName = match[1];
            // }
            // link.setAttribute("download", fileName);
            // document.body.appendChild(link);
            // link.click();
            // link.remove();
            // window.URL.revokeObjectURL(url);

            // Swal.fire({
            //   icon: "success",
            //   title: "Berhasil!",
            //   text: "Export Excel berhasil diunduh.",
            //   timer: 2000,
            //   showConfirmButton: false,
            // });
          })
          .catch((error) => {
            console.error(error);
            Swal.fire({
              icon: "error",
              title: "Gagal!",
              text: "Terjadi kesalahan saat export Excel.",
            });
          });
      });
    },

    translateEnglish(label){
      let finalLabel = '';
      switch(label) {
        case 'Deteksi Kebisingan':
          finalLabel = 'Noise';
          break;
        case 'Deteksi Wajah':
          finalLabel = 'Multiple Faces';
          break;
        case 'Perpindahan Tab/Fokus':
          finalLabel = 'Tab Switch';
          break;
        case 'Deteksi Multiple Monitor':
          finalLabel = 'Multiple Monitors';
          break;
        case 'Foto Acak':
          finalLabel = 'Random Photos';
          break;
        case 'Mode Layar Penuh':
          finalLabel = 'Enforce Full Screen';
          break;
        default:
          finalLabel = label;
      }

      return finalLabel;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="row">
              <!-- bagian navigasi halaman -->
              <div class="col-md-12 d-flex justify-content-between align-item-center">
                <div>
                  <b-button
                    size="sm"
                    variant="danger"
                    class="fw-bold"
                    @click="backButton"
                  >
                    <i class="fa fa-arrow-left me-1"></i>
                    Kembali
                  </b-button>
                </div>

                <div>
                  <b-button
                    size="sm"
                    variant="info"
                    class="fw-bold me-2"
                    @click="showModalExportListQueue = true"
                  >
                    <i class="fa fa-tasks me-1"></i>
                    Export List
                  </b-button>
                  <b-button
                    size="sm"
                    variant="success"
                    class="fw-bold"
                    @click="exportExcel"
                  >
                    <i class="fa fa-file-excel me-1"></i>
                    Export
                  </b-button>
                </div>
              </div>
              <!-- --------------------- -->
              <div class="col-12"><hr/></div>
							<div class="col-12 col-lg-6">
								<table>
									<tr>
										<td class="fw-bold">Kode Tes</td>
										<td>:</td>
										<td>{{infoDataPeserta.kodeTes}}</td>
									</tr>	
									<tr>
										<td class="fw-bold">Batch</td>
										<td>:</td>
										<td>{{infoDataPeserta.batch}}</td>
									</tr>	
									<tr>
										<td class="fw-bold">Tanggal Mulai</td>
										<td>:</td>
										<td>{{ formatDateTime(infoDataPeserta.tanggalBatch) }}</td>
									</tr>
                  <tr>
										<td class="fw-bold">Tanggal Selesai</td>
										<td>:</td>
										<td>{{ formatDateTime(infoDataPeserta.tanggalSelesai) }}</td>
									</tr>	
								</table>
							</div>

							<div class="col-12 col-lg-6">
								<table>
									<tr>
										<td class="fw-bold">NIP</td>
										<td>:</td>
										<td>{{infoDataPeserta.nip}}</td>
									</tr>	
									<tr>
										<td class="fw-bold">Nama</td>
										<td>:</td>
										<td>{{infoDataPeserta.nama}}</td>
									</tr>	
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
      <!-- Validasi Bobot -->
      <div class="col-lg-12 mb-2">
        <div class="card">
          <div class="card-body">
            <div class="mb-3">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <label class="form-label fw-bold mb-0">Filter Kompetensi</label>
                <b-button
                  v-if="selectedKompetensi"
                  size="sm"
                  variant="warning"
                  class="fw-bold"
                  @click="updateDataKompetensiValiditas(selectedKompetensi)"
                >
                  <i class="fa fa-edit me-1"></i>
                  Update Validitas
                </b-button>
              </div>
              <select
                class="form-select"
                v-model="selectedKompetensi"
                @change="onFilterChange()"
              >
                <option :value="null">Semua Kompetensi</option>
                <option
                  v-for="item in listKompetensi"
                  :key="item.idkompetensi"
                  :value="item.idkompetensi"
                >
                  {{ item.nama_kompetensi }}
                </option>
              </select>
            </div>

            <!-- Semua Kompetensi: tabel per kompetensi -->
            <div v-if="!selectedKompetensi">
              <TabelSemuaKompetensi
                :key="tableKey"
                :idjadwalPeserta="headerParam.idjadwal_peserta"
              />
            </div>

            <!-- Kompetensi spesifik: breakdown indikator + kotak skor -->
            <div v-else>
              <div v-if="validasiBobot.loading" class="text-center py-3">
                <i class="fas fa-spinner fa-spin"></i> Loading...
              </div>
              <div v-else class="row">

                <!-- Kiri: Tabel breakdown -->
                <div class="col-12 col-lg-6">
                  <table class="table table-bordered table-sm mb-0">
                    <thead class="table-light">
                      <tr>
                        <th colspan="4">Total Soal: {{ validasiBobot.total_soal }}</th>
                      </tr>
                      <tr>
                        <th>Indikator</th>
                        <th class="text-center">Bobot Eror</th>
                        <th class="text-center">Nilai Error / Soal</th>
                        <th class="text-center">Subtotal Validitas Error</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in validasiBobot.breakdown_per_label" :key="item.label">
                        <td>{{ translateEnglish(item.indikator) }}</td>
                        <td class="text-center">{{ item.bobot }}%</td>
                        <td class="text-center">{{ item.count }}/{{ validasiBobot.total_soal }}</td>
                        <td class="text-center">{{ item.skor_label }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Kanan: Kotak skor & validasi -->
                <div class="col-12 col-lg-6 d-flex align-items-center justify-content-center">
                  <div
                    style="
                      border: 2px solid #dee2e6;
                      border-radius: 16px;
                      padding: 40px 48px;
                      text-align: center;
                      min-width: 220px;
                    "
                  >
                    <div style="font-size: 0.85rem; color: #6c757d; margin-bottom: 4px;">Total Skor</div>
                    <div style="font-size: 3rem; font-weight: 700; line-height: 1;">
                      {{ validasiBobot.total_skor }}%
                    </div>
                    <div
                      class="mt-3 px-3 py-1 rounded-pill d-inline-block fw-bold"
                      :style="{
                        backgroundColor: validasiBobot.is_valid ? '#d1fae5' : '#fee2e2',
                        color: validasiBobot.is_valid ? '#065f46' : '#991b1b',
                        fontSize: '1rem',
                      }"
                    >
                      {{ validasiBobot.keterangan }}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <TabelViolation
              :idjadwal="headerParam.idjadwal"
              :idjadwalBatch="headerParam.idjadwal_batch"
              :idjadwalPeserta="headerParam.idjadwal_peserta"
              :selectedKompetensi="selectedKompetensi"
            />
          </div>
        </div>
      </div>
    </div>
    <ModalExportListQueue v-model="showModalExportListQueue" type="report_proctor_peserta_detail" />
  </Layout>
</template>